var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.fontTypes[_vm.type][_vm.size], `font-${_vm.weight ? _vm.weight : _vm.fontTypes[_vm.type].weight}`, _vm.lineThrough ? 'line-through' : '']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }